export default "__VITE_ASSET__BF$mnTam__"